module.exports = __webpack_public_path__ + "img/119.3f35a16d.jpg";